const criticalStyle = ({ breakpoints }) => ({
  background: "#EF39481A !important",
  borderColor: "#EF39481A !important",
  color: "#EF3948 !important",
});
const normalStyle = ({ breakpoints }) => ({
  background: "#1AAE6F1A !important",
  borderColor: "#1AAE6F1A !important",
  color: "#1AAE6F !important",
});

const inAlertStyle = ({ breakpoints }) => ({
  background: "#FF95001A !important",
  borderColor: "#FF95001A !important",
  color: "#FF9500 !important",
});

export const alertChipStyle = (status, theme) => {
  switch (status) {
    case "Critical": return criticalStyle(theme);
    case "In alert": return inAlertStyle(theme);
    case "Normal": return normalStyle(theme);
    default: return normalStyle(theme);
  }
};